<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Device</label>
          <v-select
            multiple
            :options="deviceList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.device"
            @search="searchDevice"
            class="mb-3 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Filter</label>
          <v-select
            :options="dateList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.dateOption"
            class="mb-2 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">Start Time</label>
          <flat-pickr
            :disabled="disableDate"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              maxDate: maxDate,
              time_24hr: true,
              defaultHour: 0
            }"
            style="width: 100%"
            v-model="filter.start_time"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">End Time</label>
          <flat-pickr
            :disabled="disableDate"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              maxDate: maxDate,
              time_24hr: true,
              defaultHour: 23,
              defaultMinute: 59
            }"
            style="width: 100%"
            v-model="filter.end_time"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-button
            :disabled="loading"
            id="searchBtn"
            style="width: 100%"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="pl-5 mt-1 vs-con-loading__container"
            @click="search"
            >Search</vs-button
          >
        </div>
        <div
          v-if="actor.privilege >= 4"
          class="vx-col md:w-1/6 sm:w-1/2 w-full"
        >
          <label class="text-sm opacity-75">&nbsp;</label>
          <vs-checkbox v-model="select_all">
            <label for="" style="margin-top: 10px">Show All Device</label>
          </vs-checkbox>
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            v-if="data.length > 0"
            id="exportBtn"
            icon-pack="feather"
            icon="icon-file-text"
            color="success"
            type="gradient"
            class="mb-4 md:mb-0 vs-con-loading__container"
            @click="handleDownload"
            >Export Data</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(1000)">
              <span>1000</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(10000)">
              <span>10000</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <div class="table-container">
        <el-table
          :data="data"
          :sort-by="sort_by"
          border
          :height="data.length > 0 ? 1200 : 110"
          style="
            width: 100%;
            margin-top: 10px;
            margin-bottom: 10px;
            border-left: 1px solid #ccc;
          "
        >
          <el-table-column
            label="No"
            width="68"
            type="index"
            :index="indexMethod"
            :key="1"
          >
          </el-table-column>
          <el-table-column
            prop="plate"
            label="Plate"
            sortable
            width="250"
            :key="2"
          ></el-table-column>
          <el-table-column
            prop="date"
            label="Date"
            sortable
            width="150"
            :key="3"
          >
          </el-table-column>
          <el-table-column
            prop="start_date"
            label="Start"
            sortable
            width="200"
            :key="4"
          >
          </el-table-column>
          <el-table-column
            prop="end_date"
            label="End"
            sortable
            width="200"
            :key="5"
          >
          </el-table-column>
          <el-table-column
            prop="alarm_number"
            label="Alarm Number"
            sortable
            width="170"
            :key="6"
          >
          </el-table-column>
          <el-table-column
            prop="stop_time"
            label="Stop Time"
            sortable
            width="200"
            :key="7"
          >
          </el-table-column>
          <el-table-column
            prop="moving_time"
            label="Moving Time"
            sortable
            width="200"
            :key="8"
          ></el-table-column>
          <el-table-column
            prop="parking_time"
            label="Parking Time"
            sortable
            width="200"
            :key="9"
          ></el-table-column>
          <el-table-column
            prop="engine_opening_no"
            label="Engine Opening No"
            sortable
            width="200"
            :key="10"
          ></el-table-column>
          <el-table-column
            prop="engine_opening_time"
            label="Engine Opening TIme"
            sortable
            width="250"
            :key="11"
          ></el-table-column>
          <el-table-column
            prop="door_open_no"
            label="Door Open No"
            sortable
            width="200"
            :key="12"
          ></el-table-column>
          <el-table-column
            prop="door_open_time"
            label="Door Open Time"
            sortable
            width="200"
            :key="13"
          ></el-table-column>
          <el-table-column
            prop="mileage"
            label="Mileage"
            sortable
            width="150"
            :key="14"
          ></el-table-column>
          <el-table-column
            prop="average_speed"
            label="Average Speed (km/h)"
            sortable
            width="250"
            :key="15"
          ></el-table-column>

          <div
            slot="append"
            v-if="data.length < 1 || loading"
            class="table_empty"
          >
            {{ loading ? 'Loading....' : 'No Data Available' }}
          </div>
        </el-table>
        <vs-pagination :total="n_page" v-model="page" goto></vs-pagination>
      </div>
    </div>
  </div>
</template>

<style>
[dir='ltr'] .el-table .cell {
  padding-left: 10px;
  padding-right: 10px;
}

.el-table thead {
  color: #ffff;
  font-weight: bold;
}

[dir] .el-table--border::after,
[dir] .el-table--group::after,
[dir] .el-table::before {
  background-color: #ccc;
}

[dir] .el-table th.el-table__cell {
  background-color: #eee;
  font-size: 14px;
  color: #626262;
}

[dir] .el-table tr:active .el-table__cell {
  background-color: rgb(198, 198, 198);
}

[dir] .el-table td.el-table__cell,
[dir] .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #ccc;
}

[dir] .el-table .ascending .sort-caret.ascending {
  border-bottom-color: #ffff;
}

[dir] .el-table .descending .sort-caret.descending {
  border-top-color: #ffff;
}

.el-table--border .el-table__cell,
[dir='ltr']
  .el-table__body-wrapper
  .el-table--border.is-scrolling-left
  ~ .el-table__fixed {
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
}

[dir] .el-table .el-table__cell {
  padding: 7px 0;
}

.el-table__empty-block {
  display: none !important;
}

.table_empty {
  text-align: center;
  font-size: 13px;
  padding: 10px;
  border-left: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.table_total {
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
}
</style>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import FileDownload from 'js-file-download'

export default {
  components: {
    flatPickr,
    vSelect
  },

  data() {
    return {
      data: [],
      token: '',
      action: '',
      loading: false,
      actor: '',
      tempId: 0,
      disableDate: true,

      filter: {
        device: '',
        start_time: '',
        end_time: '',
        dateOption: { value: '', label: '-- Select Filter --' }
      },

      filtered: {
        device: '',
        start_time: '',
        end_time: '',
        dateOption: { value: '', label: '-- Select Filter --' }
      },

      deviceList: [],
      dateList: [
        { value: '', label: '-- Select Filter --' },
        { value: 'yesterday', label: 'Yesterday' },
        { value: 'define', label: 'Select Date' }
      ],
      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error',
      today: '',
      yesterday: '',
      twoDaysAgo: '',

      maxDate: '',

      sort_by:
        ({ prop: 'plate', order: 'descending' },
        { prop: 'date', order: 'descending' },
        { prop: 'start_date', order: 'descending' },
        { prop: 'end_date', order: 'descending' },
        { prop: 'alarm_number', order: 'descending' },
        { prop: 'stop_time', order: 'descending' },
        { prop: 'moving_time', order: 'descending' },
        { prop: 'parking_time', order: 'descending' },
        { prop: 'engine_opening_no', order: 'descending' },
        { prop: 'engine_opening_time', order: 'descending' },
        { prop: 'door_open_no', order: 'descending' },
        { prop: 'door_open_time', order: 'descending' },
        { prop: 'mileage', order: 'descending' },
        { prop: 'average_speed', order: 'descending' }),

      filename: 'Daily Report All',
      autoWidth: true,
      bookType: 'xlsx',
      select_all: false
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    dateOption() {
      return this.filter.dateOption ? this.filter.dateOption.value : ''
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    dateOption() {
      let today = new Date()
      let yesterday = new Date(today)

      yesterday.setDate(yesterday.getDate() - 1)
      today = this.formatDate(today.toDateString())
      yesterday = this.formatDate(yesterday.toDateString())

      this.disableDate = true
      // if (this.dateOption == 'today') {
      //   this.filter.start_time = this.today + ' 00:00'
      //   this.filter.end_time = this.today + ' 23:59'
      //   this.maxDate = this.today + ' 23:59'
      // } else
      if (this.dateOption == 'yesterday') {
        this.filter.start_time = this.yesterday + ' 00:00'
        this.filter.end_time = this.yesterday + ' 23:59'
        this.maxDate = this.yesterday + ' 23:59'
      } else {
        this.filter.start_time = ''
        this.filter.end_time = ''
        this.filter.end_time = this.yesterday + ' 23:59'
        this.maxDate = this.yesterday + ' 23:59'
        this.disableDate = false
      }
    },

    select_all(val) {
      this.select_all = val
    }
  },

  created() {
    let today = new Date()
    let yesterday = new Date(today)
    let twoDaysAgo = new Date(today)

    yesterday.setDate(yesterday.getDate() - 1)
    twoDaysAgo.setDate(twoDaysAgo.getDate() - 2)

    this.today = this.formatDate(today.toDateString())
    this.yesterday = this.formatDate(yesterday.toDateString())
    this.twoDaysAgo = this.formatDate(twoDaysAgo.toDateString())

    // this.maxDate = this.twoDaysAgo
    this.maxDate = `${this.today} 23:59`

    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.searchDevice('')
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {},

  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.per_page + (index + 1)
    },

    updatePerPage(n) {
      this.per_page = n
    },

    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('-')
    },

    searchDevice(keyword) {
      if (this.actor.privilege >= 4) {
        this.getDataDevice(keyword)
      } else {
        if (keyword.length >= 3) {
          this.getDataDevice(keyword)
        } else {
          this.deviceList = []
        }
      }
    },

    getDataDevice(keyword) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }

      this.timer = setTimeout(() => {
        this.$http
          .get(
            `${this.$api.endpoint}/tracking/search?keyword=${keyword}&type=vehicle`,
            {
              headers: {
                Authorization: `Bearer ${this.token}`
              }
            }
          )
          .then((res) => {
            this.deviceList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      }, 1000)
    },

    initTable() {
      this.loading = true
      this.data = []

      let imei = []
      if (this.filter.device.length > 0)
        this.filter.device.map((item) => [imei.push(parseInt(item.value))])

      this.$http
        .get(`${this.$api.endpoint}/report/daily_all_report`, {
          params: {
            page: this.page,
            per_page: this.per_page,
            device: imei.length > 0 ? JSON.stringify(imei) : '',
            start: `${this.filter.start_time}:00`,
            end: `${this.filter.end_time}:00`,
            all_unit: this.select_all
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
          this.row_total = res.data.message.total
          this.data = res.data.message.data

          this.data.map((item, index) => {
            this.data[index].no = index + 1
            this.data[index].stop_time = this.secondsToHms(item.stop_time)
            this.data[index].moving_time = this.secondsToHms(item.moving_time)
            this.data[index].parking_time = this.secondsToHms(item.parking_time)
            this.data[index].engine_opening_time = this.secondsToHms(
              item.engine_opening_time
            )
            this.data[index].door_open_time = this.secondsToHms(
              item.door_open_time
            )
            this.data[index].mileage =
              (item.mileage / 1000)
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' Km'

            this.data[index].average_speed = parseFloat(item.average_speed)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          })
        })
        .catch((error) => {
          console.log(error)
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    search() {
      this.loading = true
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#searchBtn',
        scale: 0.45
      })

      this.filtered.device = this.filter.device
      this.filtered.start_time = this.filter.start_time
      this.filtered.end_time = this.filter.end_time
      this.filtered.used_fuel = this.filter.used_fuel

      this.page = 1
      this.initTable()
    },

    exportReport() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      let imei = []
      this.filtered.device.map((item) => [imei.push(parseInt(item.value))])

      this.$http
        .get(`${this.$api.endpoint}/report/export_mileage_report`, {
          responseType: 'blob',
          params: {
            imei: imei.length > 0 ? JSON.stringify(imei) : '',
            start: `${this.filtered.start_time}:00`,
            end: `${this.filtered.end_time}:00`,
            used_fuel: this.filtered.used_fuel
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)

          let filename = `POI_Summary_Report_${this.filtered.start_time
            .toString()
            .substr(0, 10)}_${this.filtered.end_time
            .toString()
            .substr(0, 10)}.xlsx`
          FileDownload(res.data, filename)
        })
        .catch((error) => {
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    handleDownload() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          'No',
          'Plate',
          'Date',
          'Start',
          'End',
          'Alarm Number',
          'Stop Time',
          'Moving Time',
          'Parking Time',
          'Engine Opening No',
          'Engine OPening Time',
          'Door Open No',
          'Door Open Time',
          'Mileage',
          'Average Speed (km/h)'
        ]
        const filterVal = [
          'no',
          'plate',
          'date',
          'start_date',
          'end_date',
          'alarm_number',
          'stop_time',
          'moving_time',
          'parking_time',
          'engine_opening_no',
          'engine_opening_time',
          'door_open_no',
          'door_open_time',
          'mileage',
          'average_speed'
        ]

        const list = this.data
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    },

    secondsToHms(seconds) {
      // second = 172800
      seconds = Number(seconds)

      let days = seconds > 86400 ? Math.floor(seconds / 86400) : 0
      seconds = days > 0 ? seconds - days * 86400 : seconds

      let hour = Math.floor(seconds / 3600)
      let minute = Math.floor((seconds % 3600) / 60)
      let sec = Math.floor((seconds % 3600) % 60)

      let dDisplay = days > 0 ? days + (hour > 0 ? ' day(s) ' : ' day(s)') : ''
      let hDisplay = hour > 0 ? hour + (minute > 0 ? ' hr ' : '  hr') : ''
      let mDisplay = minute > 0 ? minute + (sec > 0 ? ' min ' : ' min') : ''
      let sDisplay = sec > 0 ? sec + ' sec' : ''
      return dDisplay + hDisplay + mDisplay + sDisplay
    }
  }
}
</script>
